module.exports = __webpack_public_path__ + "static/media/23.k.brooke.home.0152f446.PNG";